const ADMIN = 'Administrator';
const DEV = 'Developer';
const ALUNO = 'Student';
const PROFESSOR = 'Professor';
const DIRETOR = 'Director'
const PESQUISADOR = 'Researcher'

export default [
  {
    header: 'Profissional',
  },
  {
    title: 'Coleta de Dados',
    icon: 'HomeIcon',
    role: [DEV, ADMIN, PESQUISADOR],
    children: [
      {
        title: 'Endereços dos Alunos',
        route: 'AlunosEnderecosLista',
      },
      {
        title: 'Visitas domiciliares',
        route: 'ColetaDadosCampo',
      },
      {
        title: 'Questionários dos Alunos',
        route: 'QuestionarioSocioLista',
      },
      {
        title: 'Semanas Epidemiológicas',
        route: 'SemanaEpidemiologicaLista',
      },
    ]
  },
  {
    title: 'Indicadores',
    icon: 'ActivityIcon',
    role: [DEV, ADMIN, PESQUISADOR, PROFESSOR],
    children: [
      {
        title: 'Painel de Autoeficácia',
        route: 'painel-autoeficacia',
      },
      {
        title: 'Dashboards',
        route: 'estatisticas',
      },
    ],
  },


  {
    title: 'Educação',
    icon: 'BookOpenIcon',
    children: [
      {
        title: 'Escolas',
        route: 'EscolasLista',
        role: [ADMIN, DEV],
      },
      {
        title: 'Professores',
        route: 'ProfessorLista',
        role: [ADMIN, DEV, DIRETOR],
      },
      // {
      //   title: 'Profissionais',
      //   route: '',
      // },
      // {
      //   title: 'Patronos',
      //   route: 'ProfessorLista',
      // },
      {
        role: [ADMIN, DEV, PROFESSOR, PESQUISADOR],
        title: 'Alunos',
        route: 'Alunos',
      },
      {
        role: [ADMIN, DEV, PROFESSOR, PESQUISADOR],
        title: 'Questionário Sociodemográfico',
        route: 'QuestionarioSocioLista',
      },



    ],
  },

  {
    title: 'Desafios',
    icon: 'BarChart2Icon',
    role: [DEV, PROFESSOR, ADMIN, PESQUISADOR],
    children: [
      // {
      //   title: 'Novo Desafio',
      //   route: 'selecionarmodelo',
      // },
      {
        title: 'Avaliar',
        route: 'avaliar',
      },
      {
        title: 'Adicionar Pontos',
        route: 'PontosManuaisLista',
      },
      // {
      //   title: 'Novo Desafio',
      //   route: 'novoDesafio',
      // },
      // {
      //   title: 'Todos os Desafios',
      //   route: 'todosdesafios',
      // },
      // {
      //   title: 'Modelos',
      //   route: 'modelos',
      // },
    ]
  },


  // {
  //   title: 'Saúde',
  //   icon: 'HeartIcon',
  //   children: [
  //     {
  //       title: 'Profissionais',
  //       route: '',
  //     },
  //     {
  //       title: 'Jovem ACE',
  //       route: '',
  //     },


  //   ],
  // },

  {
    title: 'Pesquisa',
    icon: 'SearchIcon',
    role: [DEV, ADMIN, PESQUISADOR],
    children: [
      {
        title: 'Pesquisadores',
        route: 'PesquisadorLista',
      },
    ],
  },
  // {
  //   title: 'Agenda',
  //   icon: 'CalendarIcon',
  //   route: 'agenda',
  // },

  // {
  //   title: 'Ranking',
  //   icon: 'AwardIcon',
  //   route: '',

  // },
  // {
  //   title: 'Indicadores',
  //   icon: 'PieChartIcon',
  //   route: '',
  // },
  {
    title: 'Relatórios',
    icon: 'FileTextIcon',
    route: 'relatorios',
    role: [DEV, ADMIN, PESQUISADOR, PROFESSOR, DIRETOR],
  },
]
